import axios from "axios";
import { getItemWebStorage } from "../features/webStorageSaver";
import { store } from "../stateManagement/store";

export async function fetchDocumentFile(documentId: any) {
    const currentApiUrl = getItemWebStorage("currentApiUrl")
    const token = store.getState().auth.tokens.app
    try {
        const url = `${currentApiUrl}/documents/download?Id=${documentId}&Token='${token}'`;
        const response = await axios.get(url, {
            responseType: 'blob'
        });
        return response?.data
    } catch (error: any) {
        // Если сервер ответил с ошибкой
        if (error.response) {
            console.error('Ошибка с ответом сервера:', error.response.data);
        }
        // Если запрос был отправлен, но ответа не получено
        else if (error.request) {
            console.error('Сервер не ответил:', error.request);
        }
        // Если произошла другая ошибка при настройке запроса
        else {
            console.error('Ошибка запроса:', error.message);
        }
        return false
    }
}

export async function fetchDocumentView(documentId: any) {
    const currentApiUrl = getItemWebStorage("currentApiUrl")
    const token = store.getState().auth.tokens.app
    try {
        const url = `${currentApiUrl}/documents/view?Id=${documentId}&Token='${token}'`;
        const response = await axios.get(url, {
            responseType: 'blob'
        });
        return response?.data
    } catch (error: any) {
        // Если сервер ответил с ошибкой
        if (error.response) {
            console.error('Ошибка с ответом сервера:', error.response.data);
        }
        // Если запрос был отправлен, но ответа не получено
        else if (error.request) {
            console.error('Сервер не ответил:', error.request);
        }
        // Если произошла другая ошибка при настройке запроса
        else {
            console.error('Ошибка запроса:', error.message);
        }
        return false
    }
}